import { NavLink } from "react-router";
import { useMe } from "../api/hooks";
import { Shell, SupportLink, navLink } from "./Shell";

export function AdminLayout() {
  const me = useMe().data!;
  return (
    <Shell admin nav={<>
      <NavLink to="/admin" end className={navLink}>Overview</NavLink>
      <NavLink to="/admin/locations" className={navLink}>Locations</NavLink>
      <NavLink to="/admin/rules" className={navLink}>Rules</NavLink>
      <NavLink to="/admin/staff" className={navLink}>Staff</NavLink>
      <NavLink to="/admin/activity" className={navLink}>Activity</NavLink>
      <NavLink to="/admin/analytics" className={navLink}>Analytics</NavLink>
      <NavLink to="/admin/usage" className={navLink}>Usage</NavLink>
      <NavLink to="/admin/results" className={navLink}>Results</NavLink>
      <NavLink to="/admin/directory" className={navLink}>Owner directory</NavLink>
      <NavLink to="/admin/system" className={navLink}>System</NavLink>
      {me.superAdmin && <NavLink to="/admin/admins" className={navLink}>Admins</NavLink>}
      {me.superAdmin && <NavLink to="/admin/api-clients" className={navLink}>API keys</NavLink>}
      <SupportLink />
    </>} />
  );
}
